import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';
import type { ProofType } from 'types/entities/proofType';

export interface ClientIdentificationsIdentificationDocumentPostOptions {
  proofType: ProofType;
  document: File;
}

export function clientClientIdentificationsIdentificationDocumentsApi(path: string) {
  return {
    path,
    POST: (data: ClientIdentificationsIdentificationDocumentPostOptions) =>
      api.post<JsonApiResponseSingle>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(data),
          },
        })
      ),
  };
}
